module.exports = "img/CaseStudy.98e854.png";